import React, { createElement, useEffect, useState } from 'react';
import { Form, Button, Col, Table, message, Spin, Tag, Tooltip } from 'antd';
import { VerticalAlignBottomOutlined } from '@ant-design/icons';
import cls from 'classnames/bind';
import style from './index.module.scss';
import { downloadFile } from '../../../utils';
import { getDynamicTableData, getCurrentColumnMetadata, expoortDynamicTableData, } from '../../../api/form';
import { fetchReport } from '../../../api/common';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
const cx = cls.bind(style);
const { Column } = Table;
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const edit = urlParams.get('edit');
const pLineId = urlParams.get('pLineId');
const defaultPagination = { current: 1, pageSize: 5 };
const arraytype = [
    'FormCascaderMultiple',
    'FormRangeDatePicker',
    'FormMultipleSelect',
    'FormCheckbox',
    'FormOrganizationalTree',
    'FormPersonnel',
];
const FormChildren = (props, ref) => {
    const { title, reportId, span, column } = props;
    const [total, setTotal] = useState(0);
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const queryList = (pagination) => {
        try {
            const params = {
                reportId,
                pageNum: pagination.current,
                pageSize: pagination.pageSize,
                queryCriteriaList: [
                    {
                        columnName: 'pid',
                        columnValue: pLineId,
                        operator: 'eq',
                    },
                ],
            };
            getDynamicTableData(params).then((res) => {
                setData(res.rows);
                setTotal(res.total);
            });
            getCurrentColumnMetadata(reportId).then((res) => {
                const temp = [];
                res.data.forEach((item) => {
                    if (!item.defaultFlag && item.componentName !== 'FormChildren') {
                        temp.push({
                            key: item.columnId,
                            title: item.columnDescription,
                            dataIndex: item.columnName,
                            componentName: item.componentName,
                        });
                    }
                });
                setColumns(temp);
            });
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('获取子表单数据失败,请重新配置子表单或更新组件');
        }
    };
    const exportHandle = async () => {
        const params = {
            reportId,
            queryCriteriaList: [
                {
                    columnName: 'pid',
                    columnValue: pLineId,
                    operator: 'eq',
                },
            ],
        };
        setLoading(true);
        try {
            const info = await fetchReport(reportId);
            expoortDynamicTableData(params).then((res) => {
                downloadFile(res, `${info.data.reportName}_${new Date().toLocaleString()}`);
                setLoading(false);
            });
        }
        catch (error) {
            console.log(error);
            setLoading(false);
            return message.error(error);
        }
    };
    useEffect(() => {
        setError(false);
        try {
            if (edit === '3') {
                queryList(defaultPagination);
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('获取子表单数据失败,请重新配置子表单或更新组件');
        }
    }, []);
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement(React.Fragment, null, !edit || edit === '3' ? (createElement(Col, { span: column || span },
        createElement(Spin, { spinning: loading, tip: "Loading..." },
            createElement("div", { ref: ref },
                createElement(Form.Item, { label: title || '子表单名称' }, edit === '3' ? (createElement("div", { className: cx('children_form') },
                    createElement(Button, { onClick: exportHandle, size: "small", style: { marginBottom: '5px' } },
                        createElement(VerticalAlignBottomOutlined, null),
                        "\u5BFC\u51FA"),
                    createElement(Table, { onChange: queryList, dataSource: data, pagination: { total, pageSize: 5 } }, columns.map((e) => {
                        if (arraytype.includes(e.componentName)) {
                            return (createElement(Column, { title: e.title, dataIndex: e.dataIndex, key: e.dataIndex, ellipsis: {
                                    showTitle: true,
                                }, render: (tags) => (createElement("div", { onWheel: (e) => {
                                        e.currentTarget.scrollLeft += e.deltaY;
                                    }, className: cx('scroll') }, tags
                                    ? (Array.isArray(tags) ? tags : tags.split(',')).map((tag) => (createElement(Tag, { color: "blue", key: tag }, tag)))
                                    : null)) }));
                        }
                        else {
                            return (createElement(Column, { title: e.title, dataIndex: e.dataIndex, key: e.dataIndex, ellipsis: {
                                    showTitle: false,
                                }, render: (text) => createElement(Tooltip, { title: text }, text) }));
                        }
                    })))) : (createElement(Button, { disabled: false, type: "dashed" }, title || '子表单名称'))))))) : null))));
};
export default React.forwardRef(FormChildren);
